import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 375,
	height: 279,
	fill: "none",
	viewBox: "0 0 375 279",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			className: "animate-spin",
			style: {
				transformOrigin: "68.6% 33.7%",
				animationDuration: "30s"
			},
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#FFCA64",
					d: "M275.28 93.66a18.6 18.6 0 1 1-37.18 0 18.6 18.6 0 0 1 37.18 0Z"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 285.99,
					cy: 93.67,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(90 286 93.67)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 281.25,
					cy: 109.86,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(122.68 281.25 109.86)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 268.47,
					cy: 120.95,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(155.37 268.47 120.95)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 251.64,
					cy: 123.34,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(-171.84 251.64 123.34)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 236.29,
					cy: 116.27,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(-138.96 236.3 116.27)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 227.21,
					cy: 102.06,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(-106.25 227.21 102.06)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 227.27,
					cy: 85.06,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(-73.32 227.27 85.06)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 236.45,
					cy: 70.93,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(-40.63 236.45 70.93)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 251.91,
					cy: 63.96,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(-7.73 251.91 63.96)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 268.62,
					cy: 66.46,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(25.06 268.62 66.46)"
				}),
				/* @__PURE__ */ _jsx("ellipse", {
					cx: 281.36,
					cy: 77.65,
					fill: "#FFCA64",
					rx: 2.4,
					ry: 4.2,
					transform: "rotate(57.74 281.36 77.65)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6B5757",
			d: "M14.43 177c0-.04.03-.07.07-.07l6.58-.47c.04 0 .08.03.08.06l.1 3.57c0 .04-.03.07-.07.07l-6.59.2a.07.07 0 0 1-.07-.07l-.1-3.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237D45",
			d: "m30.49 152.85-27.1.78c-.1 0-.15-.1-.09-.17.87-.98 5.08-5.8 7.47-9.32 2.25-3.32 5.06-8.7 5.58-9.7a.1.1 0 0 1 .18 0c.61.96 3.92 6.13 6.39 9.35 2.54 3.32 6.79 7.95 7.65 8.88.06.07 0 .18-.08.18Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237D45",
			d: "M-.5 165.45 16.63 143a.1.1 0 0 1 .16 0l18.27 21.43a.1.1 0 0 1-.07.17l-17.59 2.17h-.02l-17.8-1.15a.1.1 0 0 1-.08-.17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237D45",
			d: "M36.7 172.62c-17.33 3.88-20.61 4.82-38.18 1.1-.08-.01-.11-.1-.06-.17l8.39-8.94 9.96-11.28a.1.1 0 0 1 .16 0l9.96 10.7 9.82 8.41c.07.06.04.16-.05.18Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6B5757",
			d: "M14.45 177.04c0-.04.02-.07.06-.07l6.59-.47c.04 0 .07.03.07.06l.1 3.57c0 .04-.03.07-.06.07l-6.6.2a.07.07 0 0 1-.07-.07l-.1-3.3Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_15597_18192",
			width: 39,
			height: 43,
			x: -2,
			y: 134,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#275653",
				fillRule: "evenodd",
				d: "m30.5 152.88-5.2.15 9.75 11.43a.1.1 0 0 1-.06.18l-6.46.8 8.23 7.03c.06.06.03.17-.05.19-.44.1-.86.2-1.28.28-16.23 3.64-19.78 4.44-36.9.82-.08-.01-.12-.11-.06-.17l7.07-7.55-5.97-.38a.1.1 0 0 1-.08-.17l9.14-11.98-5.24.15c-.1 0-.15-.1-.09-.17.87-.98 5.08-5.8 7.47-9.32a116.3 116.3 0 0 0 5.58-9.69.1.1 0 0 1 .19 0 159 159 0 0 0 6.38 9.34c2.55 3.32 6.8 7.95 7.65 8.89.06.06.01.17-.08.17Z",
				clipRule: "evenodd"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_15597_18192)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#1D1D1D",
				fillOpacity: .39,
				d: "M17.4 175.7c-1.54-11.62-12.68-15.75 2.18-38.86 7.1-8.92 15.4-21.66-8.7-1.33-30.14 25.42 8.04 51.69 6.52 40.2Z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6B5757",
			d: "M48.45 159c0-.04.02-.07.06-.07l9.82-.7c.04 0 .08.03.08.07l.15 5.35c0 .04-.03.07-.06.07l-9.84.29a.07.07 0 0 1-.07-.07l-.14-4.94Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237D45",
			d: "m72.34 123.24-40.38 1.17c-.1 0-.15-.1-.09-.17 1.1-1.23 7.53-8.56 11.15-13.9 3.4-5 7.67-13.2 8.3-14.43a.1.1 0 0 1 .18-.01 237.2 237.2 0 0 0 9.52 13.93 235.11 235.11 0 0 0 11.4 13.24c.06.07.01.17-.08.17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237D45",
			d: "m26.25 142 25.47-33.39a.1.1 0 0 1 .16 0l27.16 31.87a.1.1 0 0 1-.06.17l-26.15 3.22h-.02l-26.49-1.7a.1.1 0 0 1-.07-.17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237D45",
			d: "M81.54 152.52c-25.8 5.77-30.63 7.16-56.76 1.64-.08-.02-.12-.12-.06-.18l12.48-13.3L52 123.9a.1.1 0 0 1 .16 0l14.8 15.9 14.63 12.53c.06.05.03.16-.05.18Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#6B5757",
			d: "M48.47 159.05c0-.03.03-.06.07-.07l9.82-.7c.04 0 .08.03.08.07l.15 5.35c0 .04-.03.08-.07.08l-9.83.28a.07.07 0 0 1-.07-.07l-.15-4.94Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_15597_18192",
			width: 58,
			height: 63,
			x: 24,
			y: 95,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#275653",
				fillRule: "evenodd",
				d: "m72.37 123.3-7.8.23 14.5 17a.1.1 0 0 1-.07.18l-9.66 1.19 12.27 10.5c.07.05.04.16-.05.18l-2 .45c-24.06 5.4-29.3 6.57-54.75 1.19-.08-.02-.12-.12-.06-.18L35.3 142.8l-8.95-.58a.1.1 0 0 1-.08-.17l13.6-17.8-7.88.22c-.1 0-.15-.1-.09-.17 1.09-1.23 7.52-8.56 11.14-13.9 3.4-5 7.68-13.2 8.31-14.43a.1.1 0 0 1 .18 0c.75 1.17 5.78 9.05 9.51 13.92a235.54 235.54 0 0 0 11.4 13.24c.07.07.02.17-.07.18Z",
				clipRule: "evenodd"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_15597_18192)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#1D1D1D",
				fillOpacity: .39,
				d: "M52.86 157.12c-2.28-17.22-18.79-23.34 3.22-57.58 10.53-13.21 22.82-32.08-12.9-1.97-44.65 37.65 11.93 76.57 9.68 59.55Z"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FBFBFB",
			d: "m-10.04 189.8 2.74 27.44a11.5 11.5 0 0 0 11.25 10.35l382.31 6.57c10.51.18 15.73-12.68 8.07-19.88l-97.21-91.34a6.15 6.15 0 0 0-7.82-.5 6.15 6.15 0 0 1-6.94.17l-40.11-25.98a11.5 11.5 0 0 1-5.16-11.05l1.47-12.06A11.5 11.5 0 0 0 234.15 63l-15.98-12.23a11.5 11.5 0 0 0-14.5.43l-19.1 16.5a11.5 11.5 0 0 1-3.7 2.15L133.6 86.51a11.5 11.5 0 0 0-5.68 4.38l-17.02 25.03a11.5 11.5 0 0 1-9.29 5.02l-18.99.37a11.5 11.5 0 0 0-6.28 2.01L-5.1 179.17a11.5 11.5 0 0 0-4.94 10.62Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_15597_18192",
			width: 309,
			height: 188,
			x: 16,
			y: 22,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#F5F5F5",
				d: "m16.06 165.56 2.3 44.13 305.66-19.52-67.92-96-6.05 5.62-38.08-30.77 3.15-25.73-21.86-21.08-22.43 24.7-41.95 19.98-18.5 33.55-22.24 1.3-72.08 63.82Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask2_15597_18192)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#F2F1F1",
				d: "M67.96 169.18 45.4 152.64c-3.72-2.72-6.06-7.1-4.86-11.56C51.44 100.77 144.09 33.92 195.92 6.45a13.84 13.84 0 0 1 16.91 3.3l11.98 13.73a14.37 14.37 0 0 1-3.12 21.57l-36.7 23.35a14.37 14.37 0 0 0-4.86 19.1l20.77 37.42a7.3 7.3 0 0 1-10.61 9.47l-10.85-7.74a7.59 7.59 0 0 0-8.33-.33 7.6 7.6 0 0 1-8.02-.1l-15.66-10.04a12.27 12.27 0 0 0-17.83 5.35 12.27 12.27 0 0 1-3.2 4.3l-6.57 5.66a7.7 7.7 0 0 1-5.96 1.8 7.7 7.7 0 0 0-8.34 9.73l1.4 5.03a11.18 11.18 0 0 1-5.66 12.97L83 170.37a14.37 14.37 0 0 1-15.05-1.2Z"
			})
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 122.3,
			cy: 194.92,
			fill: "#F2F1F1",
			rx: 17.12,
			ry: 8.71
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 152.6,
			cy: 189.88,
			fill: "#F2F1F1",
			rx: 23.71,
			ry: 11.93
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0A73BA",
			d: "m141.78 189.67 7.26-94.98c.7-7.8 5.53-11.25 7.11-11.7 1.77 1.05 1.17 4.98.49 11.25l-7.87 96.92-6.99-1.49Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1D8AD3",
			d: "m141.15 189.68 7.26-94.99c.7-7.8 6.01-11.16 7.6-11.62 1.76 1.06.67 4.9 0 11.17l-7.88 96.92-6.98-1.48Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#191919",
			fillOpacity: .11,
			d: "M144.72 143.53c3.35 12.26 4.26 41.09 3.55 43.42-.88 2.92-5.67-42.64-3.55-43.42Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D9D9D9",
			d: "m141.37 191.81-8.53-94.75c-.6-7.8 1.12-10.51 2.6-11.23 1.9.75 4.42 3.24 4.78 9.53l8.26 96.76-7.1-.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "m141.37 191.81-8.53-94.75c-.6-7.8 1.12-10.51 2.6-11.23 1.9.75 4.42 3.24 4.78 9.53l8.26 96.76-7.1-.3Z"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "mask3_15597_18192",
			width: 17,
			height: 108,
			x: 132,
			y: 85,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#D9D9D9",
				d: "m141.37 191.81-8.53-94.75c-.6-7.8 1.12-10.52 2.6-11.23 1.9.75 4.42 3.24 4.78 9.52l8.26 96.77-7.1-.3Z"
			}), /* @__PURE__ */ _jsx("path", {
				fill: "#18A0FB",
				d: "m141.37 191.81-8.53-94.75c-.6-7.8 1.12-10.52 2.6-11.23 1.9.75 4.42 3.24 4.78 9.52l8.26 96.77-7.1-.3Z"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask3_15597_18192)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#FA4969",
					d: "m133.39 128.04 1.41-.11-.12-1.38-1.41.12zm-1.72-32.44 28.98-2.37-4.12-46.63-28.98 2.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FA4969",
					d: "m140.72 95.62 1.42-.11-.12-1.38-1.42.12zm2.46 30.24 1.42-.12-.12-1.37-1.42.11zm1.54 1.25 1.42-.11-.12-1.38-1.42.12z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FA4969",
					d: "m146.02 125.63 1.42-.12-.13-1.37-1.41.11zm1.54 1.25 1.41-.11-.12-1.38-1.41.12z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m133.49 104.13-.1-1.37.7-.05.1 1.36zm.26 3.42.1 1.37.71-.05-.1-1.37zm.5-2.79-.1-1.37.7-.05.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m134.4 106.81.11 1.37.71-.05-.1-1.37zm.61-1.41-.1-1.37.7-.05.11 1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m135.06 106.08.1 1.37.72-.05-.1-1.37zm.71-.05-.1-1.37.7-.05.11 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m135.72 105.34.1 1.37.7-.05-.1-1.37zm.83-7.64-.1-1.37.7-.05.1 1.37zm.26 3.43.11 1.36.7-.05-.1-1.37zm.5-2.8-.1-1.36.7-.05.11 1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m137.47 100.39.1 1.36.72-.05-.1-1.37zm.61-1.42-.1-1.37.7-.05.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m138.13 99.65.1 1.37.71-.05-.1-1.37zm.71-.05-.1-1.36.7-.06.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m138.78 98.92.1 1.36.71-.05-.1-1.36zm-1.25 2.16.1 1.36-.7.05-.11-1.36zm-.27-3.43-.1-1.37-.7.05.1 1.37zm-.5 2.79.1 1.37-.7.05-.1-1.37zm-.16-2.05-.1-1.37-.7.05.1 1.37zm-.6 1.41.1 1.37-.7.05-.1-1.36zm-.05-.68-.1-1.36-.71.05.1 1.36zm-.71.05.1 1.37-.7.05-.1-1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m135.3 99.86-.11-1.37-.71.05.1 1.37zm6.24 7.13.1 1.36-.7.05-.1-1.36zm-.26-3.43-.1-1.36-.71.05.1 1.36zm-.5 2.79.1 1.37-.7.05-.1-1.37zm-.16-2.05-.1-1.37-.71.05.1 1.37zm-.6 1.42.1 1.37-.7.05-.11-1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m139.97 105.03-.1-1.36-.72.05.1 1.36zm-.71.06.1 1.36-.7.05-.11-1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m139.31 105.77-.1-1.37-.7.05.1 1.37zm-5.98-3.71-.05-.68.7-.05.06.68zm.76.64-.05-.69.7-.05.06.69zm.76.64-.05-.7.7-.04.06.69zm.76.63-.05-.69.7-.05.06.69zm.76.63-.05-.68.7-.05.06.68zm.76.64-.05-.69.71-.05.05.69zm4.57 3.81.05.69-.7.05-.06-.69zm-.76-.64.05.69-.7.05-.06-.69zm-.76-.63.05.68-.7.06-.06-.7zm-.76-.64.05.7-.7.04-.06-.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m138.66 106.51.06.69-.71.05-.05-.69zm-.76-.64.05.7-.71.04-.05-.69zm-3.99 3.73.05.7.71-.06-.05-.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m134.57 108.87.05.69.71-.05-.05-.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m135.22 108.13.06.7.7-.06-.05-.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m135.88 107.4.05.69.7-.05-.04-.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m136.53 106.66.06.69.7-.05-.05-.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m137.19 105.92.05.7.71-.06-.05-.69zm3.93-4.41-.05-.69-.71.05.05.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m140.46 102.25-.05-.7-.71.06.05.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m139.8 102.98-.04-.69-.71.05.05.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m139.15 103.72-.05-.69-.7.05.05.69zm-.65.73-.06-.68-.7.05.05.68zm-.66.74-.05-.69-.7.05.04.69zm-1.36.79-.05-.7.7-.04.06.69zm1.42-.11-.06-.68.71-.06.06.7zm-4.25.31-.06-.69.71-.05.06.69zM136 99.8l-.04-.68.7-.05.06.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m136.77 100.44-.06-.68.71-.06.05.7zm-.11-1.37-.05-.69.7-.05.06.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m137.42 99.7-.05-.68.7-.05.06.69zm3.31 5.97-.05-.68.7-.05.06.68zM132.1 91.1l-.1-1.37.7-.05.1 1.36zm.26 3.42.1 1.37.72-.05-.1-1.37zm.5-2.79-.1-1.37.7-.05.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m133.02 93.78.1 1.37.72-.05-.11-1.37zm.6-1.42-.1-1.36.7-.05.1 1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m133.67 93.05.1 1.37.71-.05-.1-1.37zm.71-.05-.1-1.37.7-.05.11 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m134.32 92.31.1 1.37.72-.05-.1-1.37zm1.11-4.21.1 1.37.71-.05-.1-1.37zm.66-.74.1 1.37.7-.05-.1-1.37zm.6-1.41-.1-1.37.7-.05.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m136.74 86.63.1 1.37.71-.05-.1-1.37zm.71-.05-.1-1.36.7-.05.1 1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m137.4 85.9.1 1.36.7-.05-.1-1.36zm-1.26 2.15.1 1.37-.7.05-.1-1.37zm-.76-.63.1 1.36-.7.05-.11-1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m134.62 86.78.1 1.37-.7.05-.1-1.37zm-.06-.68-.1-1.37-.7.05.1 1.37zm-.7.05.1 1.36-.7.05-.11-1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m133.91 86.83-.1-1.37-.71.05.1 1.37zm6.25 7.13.1 1.37-.7.05-.11-1.37zm-.26-3.42-.11-1.37-.71.05.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m139.4 93.33.1 1.36-.71.05-.1-1.36zm-.17-2.05-.1-1.37-.7.05.1 1.37zm-.6 1.42.1 1.36-.7.05-.1-1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m138.58 92-.1-1.36-.71.05.1 1.37zm-.71.06.1 1.37-.7.05-.1-1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m137.93 92.74-.1-1.36-.72.05.11 1.36zm-5.23-3.07-.05-.69.7-.05.06.7zm.76.63-.05-.68.7-.05.06.69zm.76.64-.05-.69.7-.05.06.7zm.76.63-.05-.68.7-.05.06.68zm.76.64-.05-.69.7-.05.06.69zm4.56 3.81.06.69-.7.05-.06-.69zm-.75-.64.05.7-.7.04-.06-.69zm-.76-.63.05.69-.7.05-.06-.69zm-.76-.64.05.7-.7.04-.06-.69zm-.76-.63.05.69-.7.05-.06-.69zm-.77-.64.06.7-.71.04-.05-.69zm-3.98 3.74.05.68.71-.05-.05-.68zm.66-.74.05.69.7-.05-.04-.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m133.83 95.1.05.69.71-.05-.05-.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m134.48 94.37.06.68.7-.05-.05-.69zm.66-.74.06.69.7-.05-.05-.69zm.66-.73.05.68.7-.05-.04-.69zm3.93-4.42-.06-.69-.7.06.05.68z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m139.07 89.22-.05-.7-.71.06.05.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m138.42 89.96-.06-.7-.7.06.05.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m137.77 90.69-.05-.69-.71.05.05.69zm-.67.74-.04-.69-.71.05.05.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m136.45 92.16-.05-.69-.71.05.05.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m135.09 92.95-.05-.7.7-.04.06.69zm1.41-.11-.05-.68.7-.05.06.68zm-4.24.31-.06-.69.71-.05.05.69zm2.36-6.37-.06-.69.71-.05.06.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m135.37 87.41-.05-.68.7-.05.06.68zm-.1-1.37-.05-.68.7-.05.06.68zm.76.64-.05-.7.7-.04.06.69zm3.31 5.96-.05-.69.7-.05.06.69zm-4.86 24.51-.1-1.37.7-.05.1 1.37zm.26 3.42.1 1.37.72-.05-.1-1.37zm.5-2.79-.1-1.36.7-.06.11 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m135.4 119.84.1 1.37.72-.05-.11-1.37zm.6-1.43-.1-1.36.71-.05.1 1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m136.06 119.1.1 1.37.71-.05-.1-1.37zm.71-.05-.1-1.37.7-.05.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m136.7 118.37.11 1.36.71-.05-.1-1.36zm.86-7.65-.11-1.36.7-.05.11 1.36zm.26 3.43.1 1.37.71-.05-.1-1.37zm.5-2.79-.1-1.37.7-.05.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m138.47 113.41.1 1.37.72-.05-.1-1.37zm.61-1.41-.1-1.37.7-.05.1 1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m139.13 112.68.1 1.37.71-.05-.1-1.37zm.71-.05-.1-1.36.7-.06.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m139.78 111.94.1 1.37.72-.05-.1-1.37zm-1.26 2.16.1 1.37-.7.05-.1-1.36zm-.26-3.42-.1-1.37-.72.05.11 1.37zm-.5 2.79.1 1.37-.7.05-.11-1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m137.6 111.42-.1-1.37-.71.05.1 1.37zm-.6 1.42.1 1.36-.7.05-.11-1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m136.94 112.15-.1-1.37-.7.05.1 1.37zm-.7.05.1 1.37-.7.05-.11-1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m136.3 112.89-.11-1.37-.71.05.1 1.37zm6.24 7.12.1 1.37-.7.05-.1-1.37zm-.26-3.43-.11-1.36-.7.05.1 1.36zm-.5 2.8.1 1.36-.7.05-.11-1.36zm-.16-2.06-.1-1.36-.72.05.1 1.36zm-.61 1.43.1 1.36-.7.05-.1-1.36z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m140.96 118.06-.1-1.37-.71.05.1 1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m140.26 118.1.1 1.37-.7.06-.11-1.37z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m140.31 118.8-.1-1.37-.71.05.1 1.36zm-5.99-3.7-.05-.7.7-.05.06.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m135.08 115.73-.06-.69.71-.05.05.69zm.76.63-.05-.68.7-.06.06.7zm.76.64-.05-.69.7-.05.06.69zm.76.63-.05-.69.7-.05.06.69zm.76.64-.05-.69.7-.05.06.69zm4.58 3.8.05.69-.7.05-.06-.69zm-.76-.63.05.68-.7.05-.06-.68zm-.76-.64.05.69-.7.05-.06-.69zm-.76-.63.05.68-.7.05-.06-.68zm-.77-.64.05.7-.7.04-.06-.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m138.9 118.9.05.68-.71.05-.05-.68zm-4 3.73.05.69.71-.05-.05-.69zm.66-.73.05.68.71-.05-.05-.69zm.66-.74.05.68.7-.05-.05-.68zm.65-.74.05.69.7-.05-.04-.7z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m137.53 119.69.05.68.7-.05-.05-.68zm.65-.74.05.69.71-.05-.05-.7zm3.94-4.41-.06-.7-.7.06.05.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m141.47 115.27-.06-.69-.7.05.05.7zm-.67.73-.05-.68-.7.05.05.69zm-.65.74-.05-.68-.7.05.04.68zm-.65.74-.06-.69-.7.05.05.69z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m138.84 118.22-.05-.7-.71.06.05.69zm-1.37.78-.05-.69.7-.05.06.69zm1.42-.1-.05-.69.7-.05.06.69zm-4.25.3-.05-.68.7-.06.06.7zm2.36-6.37-.06-.69.7-.05.06.69zm.76.64-.05-.7.7-.04.06.68zm-.11-1.37-.05-.7.7-.04.06.69zm.77.63-.06-.69.71-.05.05.7zm3.3 5.97-.05-.7.7-.05.06.7z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFF4E0",
			d: "M137.72 150.2c.03-.79.98-4.48 1.45-6.23.72-.04 2.2-.14 2.37-.3.16-.14 2.33 5.02 3.4 7.62l-7.1.48c-.05-.2-.16-.8-.12-1.58Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#687488",
			d: "m138.95 148.87 3.94-.22 1.45 16.14-3.74.36-1.65-16.28Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2A4550",
			d: "m138.25 152.82 1.4-2.07 3.34-.28 1.76 1.84.63-.49c-.65-.7-1.99-2.12-2.2-2.22-.25-.11-3.8.37-4.11.33-.26-.04-1.2 1.71-1.63 2.59l.81.3Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 5.77,
			height: 4.46,
			x: 138.31,
			y: 150.62,
			fill: "#274253",
			rx: 2.23,
			transform: "rotate(-5.77 138.3 150.62)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1D3138",
			d: "m138.62 152.6 1.08-1.98 2.46-.29-2.19.8-1.34 2.22-.01-.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2A4550",
			d: "m146.03 165.9-1.4 2.07-3.35.28-1.75-1.84-.63.49c.64.7 1.98 2.13 2.19 2.22.26.12 3.8-.37 4.12-.33.25.04 1.19-1.71 1.62-2.59l-.8-.3Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 5.77,
			height: 4.46,
			x: 145.97,
			y: 168.1,
			fill: "#274253",
			rx: 2.23,
			transform: "rotate(174.22 145.97 168.1)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1D3138",
			d: "m145.65 166.12-1.09 1.99-2.45.28 2.19-.8 1.33-2.22.02.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#687488",
			d: "M139.3 143.87c-.27.06-.39 3.36-.35 5 1.25-.06 3.35-.05 3.94-.22-.17-.6-.85-3.38-1.4-4.94a5.98 5.98 0 0 0-2.19.16Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CDD1D7",
			d: "m139.91 192.28-35.06-51.84-1.54.71 35.06 51.84 1.54-.7Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#354661",
			d: "M105.67 140.65c-.62-.15-4.81-6.13-6.83-9.1-3.08.45-3.89 2.2-3.9 3.02.63.2 2.07.6 2.75.54.84-.06.36 2.43 1.17 1.94.8-.49 3.28 3.97 3.64 4.2.28.18-.16.83-.42 1.13l.78 1.3 1.94-1.18c1.62-.98 2.2-1.1 2.58-1.56.4-.46-.94-.1-1.71-.29Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CDD1D7",
			d: "m134.1 192.34-13.21-61.18-1.7.08 13.2 61.18 1.7-.08Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#354661",
			d: "M121.56 131.66c-.52-.38-2.18-7.49-2.94-11-3.03-.72-4.43.6-4.76 1.36.52.42 1.71 1.32 2.36 1.52.8.25-.57 2.39.36 2.24.93-.15 1.57 4.9 1.81 5.25.2.27-.45.71-.8.9l.24 1.48 2.23-.36c1.87-.3 2.46-.2 2.98-.49.53-.27-.83-.43-1.48-.9Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEB95E",
			d: "M162.73 174.86c1-3.53 5.16-7.46 7.1-8.99l2.14.82c.77 1.55.56 8.16-.71 11.46l-4.4-1.5-4.13-1.79Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m169 166.6.9-.82c.79 0 2.28.18 2.04.91-.24.74-2.06.24-2.95-.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			stroke: "#EC4949",
			strokeWidth: .51,
			d: "m160.29 181.2 2.41-6.28a59.69 59.69 0 0 0 8.6 3.32l-2.42 6.27a35.24 35.24 0 0 1-8.6-3.32Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			d: "m170.14 164.88.6-1.55 2.39.92a7.8 7.8 0 0 1-.6 1.55l-2.39-.92Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m169.92 165.83.35-.9 2 .77-.34.9-2-.77Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FB8431",
			d: "M156.75 171.08c7.51.72 12.3 18.37-4.19 16.44-8.22-.97-10.15-17.83 4.19-16.44Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#499D69",
			d: "M160.46 169.6c-2.92-.34-4.43 2-4.82 3.2-.78 0-1.6.39 1.38 1.91 3.71 1.91 7.1-4.67 3.44-5.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F5A45C",
			d: "M161.22 179.34c1.73.6 1.63-1.61.78-2.4-1.07-1-2.75-.53-.78 2.4Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237D45",
			d: "M155.93 172.93c1.02.3 3.13.69 3.46-.2.4-1.13-2.85-.31-3.46.2Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 121.38,
			cy: 198.78,
			fill: "#fff",
			rx: 17.12,
			ry: 8.71
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 157.26,
			cy: 193.61,
			fill: "#fff",
			rx: 23.71,
			ry: 11.93
		})
	]
});
const SvgMountainMobile = styled(base)({});
export default SvgMountainMobile;
